// extracted by mini-css-extract-plugin
export default {"footer":"responsive-styles_footer__2CVdS","innerFooter":"responsive-styles_innerFooter__BoMR8","terms":"responsive-styles_terms__mm4EJ"};